/**
 * PDP Sky-Wrapper scroll behaviour
 *
 * top = max(25px, 200px - scrollY)
 * → starts at 200px when at the top, slides up to 25px minimum while scrolling.
 *
 * Visibility: hidden when the content inside a wrapper exceeds the wrapper's
 * own width (i.e. the available side space is too narrow for the content).
 */
export default () => {
  const $skyWrappers = $('.pdp-sky-wrapper');
  if (!$skyWrappers.length) {
    return;
  }

  const updateSkyWrapperState = () => {
    const top = Math.max(25, 200 - window.scrollY);
    $skyWrappers.css('top', top + 'px');
  };

  const updateSkyWrapperVisibility = () => {
    $skyWrappers.each((_, wrapper) => {
      // Temporarily reset justify-content so all content starts at the
      // left edge – this ensures scrollWidth reliably reflects overflow
      // (justify-content: flex-end causes negative overflow which
      // scrollWidth does not capture).
      const jc = wrapper.style.justifyContent;
      wrapper.style.justifyContent = 'flex-start';
      const overflows = wrapper.scrollWidth > wrapper.clientWidth;
      wrapper.style.justifyContent = jc;

      $(wrapper).css('visibility', overflows ? 'hidden' : '');
    });
  };

  // Set initial states
  updateSkyWrapperState();
  updateSkyWrapperVisibility();

  window.addEventListener('scroll', updateSkyWrapperState, { passive: true });
  window.addEventListener('resize', updateSkyWrapperVisibility, {
    passive: true,
  });

  // Re-check visibility when teaser content is injected asynchronously
  const observer = new MutationObserver(updateSkyWrapperVisibility);
  $skyWrappers.each((_, wrapper) => {
    observer.observe(wrapper, { childList: true, subtree: true });
  });
};
